import type { ShapeData } from '@/lib/shapes/types/shape-data'

/**
 * A pen-drawn path is closed when the user clicks back on the start anchor to finish it —
 * `buildPathFromPoints` (center-canvas/helpers/build-path-from-points.ts) always appends an explicit closing segment and a
 * trailing `Z` to `shape.path` in that case, so a closed loop is detectable from the SVG path
 * string alone, without needing the transient `isClosed` value from the draw gesture itself.
 */
export function isClosedPenPathShape(shape: ShapeData): boolean {
  return (
    shape.type === 'path' && typeof shape.path === 'string' && /[Zz]\s*$/.test(shape.path.trim())
  )
}
